import { render, staticRenderFns } from "./TableCoberturaVendedores.vue?vue&type=template&id=771385ec&scoped=true&"
import script from "./TableCoberturaVendedores.vue?vue&type=script&lang=js&"
export * from "./TableCoberturaVendedores.vue?vue&type=script&lang=js&"
import style0 from "./TableCoberturaVendedores.vue?vue&type=style&index=0&id=771385ec&scoped=true&lang=css&"
import style1 from "./TableCoberturaVendedores.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771385ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
